import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ allowedRoles, children }) => {
    const token = localStorage.getItem('token');
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    try {
        const decoded = jwtDecode(token);
        if (!allowedRoles.includes(decoded.role)) {
            return <Navigate to="/403" replace />;
        }
    } catch (error) {
        console.error("Token decoding failed:", error);
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
